// DetailsModal.js
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import Modal from 'react-modal';
import HttpClient from '../../utils/HttpClient';
import { jwtDecode } from 'jwt-decode';

Modal.setAppElement('#root'); // Set the root element for accessibility

const format1 = "DD-MM-YYYY, h:mm a"

const NonMemberUpgradedModal = ({ isOpen, closeModal, details }) => {


    const [tableData, setTableData] = useState([]);
    const [BcryptPassword, setBcryptPassword] = useState("")


    // fetch Category DAta
    const getCategoryData = async () => {
        // setIsLoading(true);

        const res = await HttpClient.requestData('single-user/' + details, 'GET', {});
        if (res && res?.status) {
            const token = res?.data?.[0]?.token
            const decoded = jwtDecode(token);
            setTableData(res?.data);
            setBcryptPassword(decoded?.password)
        }
    }
    useEffect(() => {
        getCategoryData();
    }, [details]);
    return (

        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Details Modal"
            className=""
        >
            <a href='#' className='mtclose' onClick={closeModal}><i className="fa-solid fa-xmark"></i></a>


            <>
                <div className=' container'>
                    <div className=' row '>
                        <div className='col-12 d-flex justify-content-center '>
                            <h2 className='  border-bottom border-danger mb-3'>User Details</h2>

                        </div>
                        <hr />
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Date & Time Created :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{moment(tableData?.[0]?.createdOn).format(format1)}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Company Name :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.companyName}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Type Of Company</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.TypeOfCompany}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Owner Name :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.personName}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Designation :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.designation}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>State :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.emirate}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Country :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.country}</p>
                        </div>
                        {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Service Type :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.service.map((item, i) => { return (<>&nbsp;<span key={i}>{item}</span>&nbsp;,</>) })}</p>
                        </div> */}
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4' >Email :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.emailId}</p>
                        </div>

                        {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Telephone :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><i className="fa-solid fa-phone"></i> - {tableData?.[0]?.telephoneNo}</p>
                        </div> */}
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Mobile No. :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><i className="fa-solid fa-mobile-screen-button"></i> - {tableData?.[0]?.phone_code} {tableData?.[0]?.mobileNo}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Whatsapp :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><i className="fa-brands fa-whatsapp"></i> - {tableData?.[0]?.whats_code} {tableData?.[0]?.whatsappNo}</p>
                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Password :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{BcryptPassword}</p>
                        </div>

                        {/* <div className='col-12 d-flex mt-3 '>
                            <h4 className='item-description col-4'>Website :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'><a href={tableData?.[0]?.websiteLink} style={{ textDecoration: "underline", cursor: "pointer" }}>{tableData?.[0]?.websiteLink}</a></p>
                        </div> */}
                        {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Address :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.address} , ({tableData?.[0]?.location})</p>
                        </div> */}
                        {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4'>Profile Name :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <p className='mt-1'>{tableData?.[0]?.userName}</p>
                        </div> */}
                       


                        {/* <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4 mt-5'>Banner :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <img src={tableData?.[0]?.banner} alt="" id='preview' height="150px" width="150px" />

                        </div>
                        <div className='col-12 d-flex mt-3'>
                            <h4 className='item-description col-4 mt-5'>Profile Photo :</h4>
                            &nbsp;&nbsp;&nbsp;
                            <img src={tableData?.[0]?.profilePhoto} alt="" id='preview' height="150px" width="150px" />

                        </div> */}


                    </div>
                </div>
            </>


        </Modal >

    );
};

export default NonMemberUpgradedModal;
